export default __webpack_public_path__ + "static/media/rail-riser.1defb2e4.svg";